/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beschaftigungsbeginn1Inputs */



/**

* @param {_Field_Beschaftigungsbeginn1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beschaftigungsbeginn1 = /** @type {((inputs?: _Field_Beschaftigungsbeginn1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beschaftigungsbeginn1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beschäftigungsbeginn")
});
export { _field_beschaftigungsbeginn1 as "_field_beschaftigungsBeginn" }